import { ZERO_INSETS, type SafeInsets } from '../render/layout';

/**
 * **读 CSS 安全区（刘海 / 圆角 / 手势条）。**
 *
 * `env(safe-area-inset-*)` 只能在 CSS 里求值，JS 拿不到。标准做法是塞一个隐藏
 * 元素、把四个 inset 填成它的 padding、再 `getComputedStyle` 读回来。
 *
 * ⚠️ 每次调用都会建/删一个 DOM 节点，**别每帧调** —— 在启动和 resize 时各一次即可。
 */
export function readSafeAreaInsets(doc: Document | undefined = typeof document === 'undefined' ? undefined : document): SafeInsets {
  if (doc === undefined || doc.body === null) return ZERO_INSETS;
  const probe = doc.createElement('div');
  probe.style.cssText =
    'position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
    'padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);';
  doc.body.appendChild(probe);
  const style = doc.defaultView?.getComputedStyle(probe);
  const px = (value: string | undefined): number => {
    const n = Number.parseFloat(value ?? '0');
    return Number.isFinite(n) ? n : 0;
  };
  const insets: SafeInsets = {
    top: px(style?.paddingTop),
    right: px(style?.paddingRight),
    bottom: px(style?.paddingBottom),
    left: px(style?.paddingLeft),
  };
  probe.remove();
  return insets;
}
